import 'dom4'
import 'svgxuse'
import domready from 'domready'
import Hurdler from 'hurdler'
import Button from '../button'
import GlobalHeader from '../global-header'
import EventSpacesSlider from '../events/event-spaces-slider'
import QRCodeProductsSlider from '../qr-code-products-slider'
import HeatAndServeProductsSlider from '../heat-and-serve-products-slider'
import HeatAndServeWhereToBuy from '../heat-and-serve-where-to-buy'
import EventEnquiry from '../events/event-enquiry'
import InfoPackOverlay from '../events/info-pack-overlay'
// import InstagramFeed from '../instagram-feed'
import SubscribeForm from '../vouchers-subscribe'
import Filter from '../woocommerce/shop/product-filter'
import MenuScroll from '../page-menus'
import FAQ from '../faq'
import Map from '../map'
import InView from '../in-view'

const touchDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)
const hurdler = new Hurdler()

domready(() => {

  if (touchDevice) {
    document.body.classList.add('touch')
  }

  document.queryAll('.button').forEach(element => {
    new Button({
      element
    })
  })

  document.queryAll('[data-component="global-header"]').forEach(element => {
    new GlobalHeader({
      element
    })
  })

  document.queryAll('[data-component="page-menus"]').forEach(element => {
    new MenuScroll({
      element
    })
  })

  document.queryAll('[data-component="faq"]').forEach(element => {
    new FAQ({
      element
    })
  })

  document.queryAll('[data-component="event-spaces-slider"]').forEach(element => {
    new EventSpacesSlider({
      element
    })
  })

  document.queryAll('[data-component="qr-code-products-slider"]').forEach(element => {
    new QRCodeProductsSlider({
      element
    })
  })

  document.queryAll('[data-component="heat-and-serve-products-slider"]').forEach(element => {
    new HeatAndServeProductsSlider({
      element
    })
  })

  document.queryAll('[data-component="heat-and-serve-where-to-buy"]').forEach(element => {
    new HeatAndServeWhereToBuy({
      element
    })
  })

  // document.queryAll('[data-component="info-pack-overlay"]').forEach(element => {
  //   new InfoPackOverlay({
  //     element
  //   })
  // })

  document.queryAll('[data-component="map"]').forEach(element => {
    new Map({
      element
    })
  })

  // document.queryAll('[data-component="instagram-feed"]').forEach(element => {
  //   new InstagramFeed({
  //     element
  //   })
  // })

  document.queryAll('[data-component="event-enquiry"]').forEach(element => {
    new EventEnquiry({
      element,
      hurdler
    })
  })

  document.queryAll('[data-component="subscribe-form"]').forEach(element => {
    new SubscribeForm({
      element
    })
  })

  // document.queryAll('.prdctfltr_wc').forEach(element => {
  //   new Filter({
  //     element
  //   })
  // })

  document.queryAll('.in-view').forEach(element => {
    new InView({
      element
    })
  })

  hurdler.run()

})



// WEBPACK FOOTER //
// ./components/app/index.js